import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './statement-document.controller';
import directive from './statement-document.directive';
import editStatementDocumentDialog from './dialog.editStatementDocumentDialog';

export default angular.module('app.components.advisory.ecat.statementDocument', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editStatementDocumentDialog,
])
  .directive('ecatStatementDocument', directive)
  .controller('ECATStatementDocumentController', controller)
  .name;

console.log('app.components.advisory.ecat.statementDocument created');
